import * as React from 'react';

import { FieldReportFullViewFilterContext, FieldReportFullViewFilterContextProvider } from 'af-root/context/fieldReportFullViewFilterContext';
import type { useFieldReportFullViewFilterContext } from 'af-root/hooks/useFieldReportFullViewFilterContext';

export default function withFieldReportFullViewFilterContext<P extends object>(
	WrappedComponent: React.ComponentType<P & { fieldReportFullViewFilters: ReturnType<typeof useFieldReportFullViewFilterContext>; }>
): React.FC<P> {
	const WithFieldReportFullView: React.FC<P> = (props: P) => {
		return (
			<FieldReportFullViewFilterContextProvider>
				<InnerComponent {...props} />
			</FieldReportFullViewFilterContextProvider>
		);
	};

	const InnerComponent: React.FC<P> = (props: P) => {
		const fieldReportFullViewFilters = React.useContext(FieldReportFullViewFilterContext);

		return <WrappedComponent fieldReportFullViewFilters={fieldReportFullViewFilters} {...props as P} />;
	};

	return WithFieldReportFullView;
}
